import classNames from 'classnames';
import React from 'react';

import type { DividerData_LineStyle, DividerNode } from './../../ricos-schema/next-schema';

import { ROOT } from '../data-hooks';
import styles from '../statics/styles/divider-viewer.rtlignore-scss';

export const DividerViewer: React.FC<{ node: DividerNode }> = ({ node }) => {
  const { lineStyle, width, alignment } = node.dividerData || {};
  const lineStyleAsLowerCase = lineStyle?.toLowerCase() as Lowercase<DividerData_LineStyle>;
  const linesPropsArr = getLines(lineStyleAsLowerCase);
  const className = classNames(
    styles['divider-container'],
    styles[`divider-container--${lineStyleAsLowerCase}`]
  );
  const lineClassName = classNames(
    styles.divider,
    styles[`divider--${lineStyleAsLowerCase}`],
    styles[`divider--${width?.toLowerCase()}`],
    styles[`divider--${alignment?.toLowerCase()}`]
  );
  return (
    <div className={className} data-hook={`${ROOT} divider-${lineStyleAsLowerCase}`}>
      {
        //fixing Tiptap bug in Safari: when selecting node-view which is svg, there is a caret below, and you can't
        //focus on empty line below the node view
        //similar issue discussed here: https://discuss.prosemirror.net/t/ios-safari-does-not-hide-the-caret-on-non-visible-selections-e-g-nodeselection/3024
      }
      <div className={styles.svgFixerContainer}>
        <svg className={lineClassName}>
          {linesPropsArr.map((lineProp, i) => (
            <line key={i} {...lineProp} />
          ))}
        </svg>
        <div className={styles.emptyChar}>&nbsp;</div>
      </div>
    </div>
  );
};

const lineProps = (lineDistance = 1) => ({
  x2: '100%',
  y1: lineDistance,
  y2: lineDistance,
});

const getLines = (type?: Lowercase<DividerData_LineStyle>) => {
  const linePropsArr = [lineProps()];
  if (type === 'double') {
    linePropsArr.push(lineProps(7));
  }
  return linePropsArr;
};
